global.API_PROXY = 'https://bird.ioliu.cn/v1/?url=http://misc.kimiss.com/common/wxapi/commonwx/104?'


// WEBPACK FOOTER //
// ./src/common/js/http.js